import { Component, Inject, OnInit, Optional } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { HelplistService } from 'app/helplist.service';

@Component({
  selector: 'app-opdtest-master-search',
  templateUrl: './opdtest-master-search.component.html',
  styleUrls: ['./opdtest-master-search.component.scss']
})
export class OPDTestMasterSearchComponent implements OnInit {
 private searchOPDmaster:any
 private opdtestarray:any=[];
  constructor(private helplistservice:HelplistService,public dialog: MatDialog,public dialogRef: MatDialogRef<OPDTestMasterSearchComponent>, @Optional() @Inject(MAT_DIALOG_DATA) public data: any) { }

  ngOnInit(): void {
    this.helplistservice.get_tests();
    this.opdtestarray= this.helplistservice.tests.slice()
  }
  closedialog() {
    this.dialogRef.close(0);
  }
  selectRowdata(rowdata){
    this.dialogRef.close(rowdata);
  }

  get filteredOPDTests() {
  if (!this.searchOPDmaster) {
    return this.opdtestarray;
  }
  const searchTerm = this.searchOPDmaster.toLowerCase();
  return this.opdtestarray.filter((test: any) =>
    test.testName?.toLowerCase().includes(searchTerm)
  );
}

}
